import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../styles/shared";
import { property } from "lit/decorators/property.js";
import { ICON_CLOSE } from "../../icons";
import { when } from "lit/directives/when.js";

@customElement("bs-chip")
export class BsChip extends LitElement {
	@property({ type: Boolean, reflect: true }) hoverable = false;
	@property({ type: Boolean, reflect: true }) removable = false;
	@property({ type: Boolean, reflect: true }) active = false;

	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					display: inline-flex;
					user-select: none;
					-webkit-user-select: none;
					align-items: center;
					justify-content: center;
					border-radius: var(--border-radius-l);
					padding: var(--space-xs) var(--space-s);
					background: var(--shade-light);
					transition: background 120ms ease-out;
					--icon-size: 12px;
					gap: var(--space-xs);
					font-size: var(--font-size-s);
				}

				:host([hoverable]) {
					cursor: pointer;
				}

				:host([hoverable]:hover) {
					background: var(--shade-normal);
				}

				:host([active]) {
					outline: 2px solid var(--chip-outline-active, var(--focus-color));
					background: var(--chip-bg-active, var(--shade-lighter));
					color: var(--chip-color-active, var(--shade-contrast-lighter));
				}
			`
		];
	}

	dispatchRemove() {
		this.dispatchEvent(new CustomEvent("remove"));
	}

	render() {
		return html`
			<slot></slot>
			${when(
				this.removable,
				() => html` <bs-icon id="remove" button @click="${this.dispatchRemove}" .icon="${ICON_CLOSE}"></bs-icon> `
			)}
		`;
	}
}
